import axios from "axios";
import { DeviceLimit, IUserDetails } from "../context/types";
import { del, get, patch, post } from "../utils/api";

export interface CreateAccess {
  userId: number;
  orderId: number;
  hash: string;
}

export interface CreateAccessTrial {
  /** Deprecated: userId теперь берётся из access-токена на бэкенде. */
  userId?: number;
}

export const createAccessTrial = async (
  _data?: CreateAccessTrial
): Promise<IUserDetails | null> => {
  try {
    return await post<IUserDetails>(`/user-server/trial`);
  } catch (e) {
    const status = axios.isAxiosError(e) ? e.response?.status : undefined;
    if (status !== undefined && status < 500) {
      throw e;
    }
    window.location.href = "/subscription-fail";
    return null;
  }
};

export interface HwidDeviceApi {
  hwid: string;
  userId: number;
  platform: string | null;
  osVersion: string | null;
  deviceModel: string | null;
  userAgent: string | null;
  requestIp: string | null;
  createdAt: string;
  updatedAt: string;
  /** Локальное имя; если null — fallback на deviceModel/platform. */
  customName: string | null;
}

export interface DevicesListResponse {
  total: number;
  devices: HwidDeviceApi[];
}

/** Полный список устройств, подключённых по HWID к подписке пользователя. */
export const getDevices = async (): Promise<DevicesListResponse> => {
  return get<DevicesListResponse>(`/user-server/devices`);
};

/** Отвязать устройство от подписки по hwid. Возвращает обновлённый список. */
export const deleteDevice = async (hwid: string): Promise<DevicesListResponse> => {
  return del(`/user-server/devices/${encodeURIComponent(hwid)}`);
};

/** Локально переименовать устройство. Возвращает обновлённый список. */
export const renameDevice = async (
  hwid: string,
  name: string
): Promise<DevicesListResponse> => {
  return patch<DevicesListResponse, { name: string }>(
    `/user-server/devices/${encodeURIComponent(hwid)}`,
    undefined,
    { name }
  );
};

/**
 * Самостоятельное уменьшение лимита устройств: без доплаты, не применяется сразу —
 * ставится в очередь и предвыбирается на экране продления подписки.
 */
export const setPendingDeviceLimit = async (
  deviceLimit: DeviceLimit
): Promise<{ pendingDeviceLimit: DeviceLimit | null }> => {
  return patch<{ pendingDeviceLimit: DeviceLimit | null }, { deviceLimit: DeviceLimit }>(
    `/user-server/device-limit/pending`,
    undefined,
    { deviceLimit }
  );
};
